import {
  MenuPostionEnum
} from "ahm-angular";

export const MENU = {
  position: MenuPostionEnum.left,
  title: "Menú",
  items: [{
    label: 'Documentos',
    icon: 'pi pi-book',
    routerLink: '/home'
    // items: [{
    //   label: 'Documentos',
    //   icon: 'pi pi-fw pi-home',
    //   routerLink: '/home'
    // }
    // ]
  },
    // {
    //   label: 'Nueva tarifa',
    //   icon: 'pi pi-calculator',
    //   routerLink: '/new-rate'
    // },
    // {
    //   label: 'Ofertas',
    //   icon: 'pi pi-calculator',
    //   routerLink: '/offers'
    // }
  ]
}
